export * from './PermissionTable2';
